module.exports = __webpack_public_path__ + "media/images/admin/icons/corner-right-down-9e1bef80aab03d14798b77260f288a85.svg";